module.exports = __webpack_public_path__ + "static/media/Niveau_elN12_4_561186.ee8b1f10.png";